module.exports = __webpack_public_path__ + "img/automation.b87425dd.svg";